import { render, staticRenderFns } from "./AskAnythingFullpage.vue?vue&type=template&id=b1a0e8bc&scoped=true&"
import script from "./AskAnythingFullpage.vue?vue&type=script&setup=true&lang=js&"
export * from "./AskAnythingFullpage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AskAnythingFullpage.vue?vue&type=style&index=0&id=b1a0e8bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a0e8bc",
  null
  
)

export default component.exports